import axios from "@/util/axios";
import getCacheBuster from "@/util/getCacheBuster";

import { createSelector } from "reselect";
import { merge } from "lodash";

const prefix = "material/details";

const FETCH_STARTED = `${prefix}/FETCH_STARTED`;
const FETCH_FAILED = `${prefix}/FETCH_FAILED`;
const FETCH_ENDED = `${prefix}/FETCH_ENDED`;
const SET_CURRENT_MATERIAL = `${prefix}/SET_CURRENT_MATERIAL`;

const initialState = {
  currentMaterialId: null,
  materialCache: {},
  isFetching: {},
  error: {},
};

const fetchStart = (id) => ({ type: FETCH_STARTED, meta: { id: id } });
const fetchEnd = (id, data) => ({ type: FETCH_ENDED, payload: data, meta: { id: id } });
const fetchFail = (id, err) => ({ type: FETCH_FAILED, payload: err, meta: { id: id }, error: true });
const setCurrentMaterial = (id) => ({ type: SET_CURRENT_MATERIAL, payload: id });

const buildPatchObject = (id, value) => {
  const o = {};
  o[id] = value;
  return o;
};

// reducer

export default function materialReducer(state = initialState, action) {
  const { type, meta, payload } = action;

  switch (type) {
    case FETCH_STARTED:
      return {
        ...state,
        isFetching: merge({}, state.isFetching, buildPatchObject(meta.id, true)),
        error: buildPatchObject(meta.id, null),
      };

    case FETCH_ENDED:
      return {
        ...state,
        materialCache: merge({}, state.materialCache, buildPatchObject(meta.id, payload)),
        isFetching: merge({}, state.isFetching, buildPatchObject(meta.id, false)),
        error: buildPatchObject(meta.id, null),
      };

    case FETCH_FAILED:
      return {
        ...state,
        isFetching: merge({}, state.isFetching, buildPatchObject(meta.id, false)),
        error: buildPatchObject(meta.id, action.payload),
      };

    case SET_CURRENT_MATERIAL:
      return {
        ...state,
        currentMaterialId: action.payload,
      };

    default:
      return state;
  }
}

// selectors

const materialSelector = (state) => state.material;

const isMaterialFetchingSelector = createSelector(materialSelector, (materialData) => materialData.isFetching);

const hasMaterialErrorSelector = createSelector(materialSelector, (materialData) => materialData.error);

const getMaterialCache = createSelector(materialSelector, (materialData) => materialData.materialCache);

const getCurrentMaterialId = createSelector(materialSelector, (materialData) => materialData.currentMaterialId);

export const isMaterialFetching = createSelector(
  isMaterialFetchingSelector,
  getCurrentMaterialId,
  (isFetching, currentMaterialId) => isFetching[currentMaterialId]
);

export const hasMaterialError = createSelector(
  hasMaterialErrorSelector,
  getCurrentMaterialId,
  (hasError, currentMaterialId) => !!hasMaterialErrorSelector[currentMaterialId]
);

export const getMaterial = createSelector(getMaterialCache, getCurrentMaterialId, (materialCache, currentMaterialId) => materialCache[currentMaterialId]);

export function fetchMaterial(id) {
  return (dispatch, getState) => {
    dispatch(setCurrentMaterial(id));

    const state = getState();
    const isFetching = isMaterialFetching(state);
    const data = getMaterial(state);

    if (isFetching || data) {
      return Promise.resolve();
    }

    dispatch(fetchStart(id));

    return axios
      .get("api/materials/details/" + encodeURIComponent(id), { params: { _: getCacheBuster() } })
      .then((res) => {
        dispatch(fetchEnd(id, res.data));
      })
      .catch((err) => {
        dispatch(fetchFail(id, err));
      });
  };
}
